import __request__ from "routing/request";
export function all(requestOptions) {
  return __request__("GET", "/events/entity_types", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
